import React, { useEffect, useState } from "react";

const InstallPWA = (props) => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const onClick = (evt) => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };
    if (!supportsPWA) {
        return null;
    }
    return (
        <div className={`flex flex-row py-4 bg-gray-800 text-gray-50 justify-center ${props.className}`}>
            <button className="font-bahij-bold w-full" id="setup_button" aria-label="Install app" title="Install app" onClick={onClick}>
                تثبيت التطبيق
            </button>
        </div>
    );
};

export default InstallPWA;
